import { linkOptions } from '@tanstack/react-router';
import { cn, getMkpReportLink } from '@anytag/shared-utils';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { useGenerateInfluencerProfileLink } from '@anytag/shared-hooks';
import { Anchor, MediaPreview, SocialIcon, TextCutter } from '@anytag/shared-atoms';
import { CampaignPost, CampaignIdentifierType, CampaignPostSocialType } from '@anytag/graphql';

interface PostColumnProps {
  avatar: string;
  content: string;
  thumbnail: string;
  className?: string;
  influencerId: number;
  influencerName: string;
  onPostClick?: () => void;
  socialPostType: CampaignPostSocialType;
  isBlockedProfileLink?: boolean;
  campaignName?: CampaignPost['campaignName'];
  campaignIdentifier: CampaignPost['campaignIdentifier'];
}
export const PostColumn = ({
  avatar,
  content,
  thumbnail,
  className,
  onPostClick,
  influencerId,
  campaignName,
  influencerName,
  socialPostType,
  campaignIdentifier,
  isBlockedProfileLink
}: PostColumnProps) => {
  const { generateProfileLink } = useGenerateInfluencerProfileLink({ disabled: isBlockedProfileLink });

  return (
    <div className={cn('flex items-center justify-start gap-6', className)}>
      <div onClick={onPostClick} className="relative cursor-pointer hover:opacity-80">
        <MediaPreview src={thumbnail} objectFit="cover" alt="post thumbnail" className="size-20 rounded-sm" />
        <div className="absolute top-0 left-0 rounded-tl-[3px] rounded-br-[5px] bg-white p-1">
          <SocialIcon size="24px" type={socialPostType} className="block" />
        </div>
      </div>

      <div className="flex h-20 flex-col justify-between">
        <Anchor className="flex w-47.5 items-center" {...generateProfileLink(influencerId)}>
          <InfluencerAvatar size="24px" src={avatar} className="rounded-sm" asChild />
          <TextCutter
            lines={1}
            css={{ fontSize: '14px', fontWeight: 600, marginLeft: '8px' }}
            text={influencerName || '-'}
          />
        </Anchor>

        <TextCutter lines={2} text={content || '-'} className="text-sm leading-[120%]" />

        <Anchor
          disabled={isBlockedProfileLink}
          {...(campaignIdentifier.campaignType === CampaignIdentifierType.MARKETPLACE
            ? getMkpReportLink({
                id: campaignIdentifier.campaignId.toString(),
                isPostTracking: campaignIdentifier.hasPostTracking,
                mkpCampaignType: campaignIdentifier.campaignDetailType
              })
            : campaignIdentifier.campaignType === CampaignIdentifierType.ENGAGEMENT
              ? linkOptions({ to: '/engagement/$id/report', params: { id: campaignIdentifier.campaignId.toString() } })
              : undefined)}
        >
          <TextCutter
            lines={1}
            onClick={() => null}
            text={campaignName || '-'}
            className="cursor-pointer text-sm leading-[calc(1em+1ex)] text-active"
          />
        </Anchor>
      </div>
    </div>
  );
};
